var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsersOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2.90267C8.35829 2.49647 8.83179 2.20901 9.35747 2.07853C9.88316 1.94805 10.4361 1.98075 10.9428 2.17227C11.4494 2.36379 11.8857 2.70505 12.1937 3.15064C12.5016 3.59623 12.6665 4.12503 12.6665 4.66667C12.6665 5.20831 12.5016 5.7371 12.1937 6.18269C11.8857 6.62829 11.4494 6.96955 10.9428 7.16107C10.4361 7.35259 9.88316 7.38528 9.35747 7.25481C8.83179 7.12433 8.35829 6.83687 8 6.43067M10 14H2V13.3333C2 12.2725 2.42143 11.2551 3.17157 10.5049C3.92172 9.75476 4.93913 9.33333 6 9.33333C7.06087 9.33333 8.07828 9.75476 8.82843 10.5049C9.57857 11.2551 10 12.2725 10 13.3333V14ZM10 14H14V13.3333C14.0001 12.6311 13.8153 11.9413 13.4643 11.3331C13.1133 10.725 12.6083 10.2199 12.0002 9.86881C11.3922 9.51767 10.7023 9.33279 10.0001 9.33277C9.29795 9.33274 8.60812 9.51757 8 9.86867M8.66667 4.66667C8.66667 5.37391 8.38572 6.05219 7.88562 6.55229C7.38552 7.05238 6.70724 7.33333 6 7.33333C5.29276 7.33333 4.61448 7.05238 4.11438 6.55229C3.61428 6.05219 3.33333 5.37391 3.33333 4.66667C3.33333 3.95942 3.61428 3.28115 4.11438 2.78105C4.61448 2.28095 5.29276 2 6 2C6.70724 2 7.38552 2.28095 7.88562 2.78105C8.38572 3.28115 8.66667 3.95942 8.66667 4.66667Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersOutline);
export default __webpack_public_path__ + "static/media/UsersOutline.544cad8a0eabb7cbaba068f454c4e142.svg";
export { ForwardRef as ReactComponent };